import { StagedAttachment, AttachmentType } from '@api/attachments/models/Attachment.model'
import StagedAttachmentEditor from '@components/common/StagedAttachmentEditor'
import useInsuranceAttachmentHook from './useInsuranceAttachmentHook'

interface StagedInsuranceAttachmentEditorProps {
  insuranceID: string
  canEdit?: boolean
  stagedAttachments: StagedAttachment[]
  onStagedAttachmentsChange: (attachments: StagedAttachment[]) => void
  attachmentType?: AttachmentType
}

const StagedInsuranceAttachmentEditor = ({
  insuranceID,
  canEdit = true,
  stagedAttachments,
  onStagedAttachmentsChange,
  attachmentType = 'Asset',
}: StagedInsuranceAttachmentEditorProps) => {
  const entityConfig = {
    entityName: 'Policy',
    entityIdLabel: 'Policy ID',
    saveMessage: 'insurance policy',
  }

  return (
    <StagedAttachmentEditor<{ insuranceID: string }>
      entityID={insuranceID}
      entityConfig={entityConfig}
      canEdit={canEdit}
      stagedAttachments={stagedAttachments}
      onStagedAttachmentsChange={onStagedAttachmentsChange}
      attachmentType={attachmentType}
      useAttachmentHook={useInsuranceAttachmentHook}
      attachmentHookParamName="insuranceID"
      maxAttachments={1}
    />
  )
}

export default StagedInsuranceAttachmentEditor